import React from 'react';
import { connect } from 'react-redux';
import { RecentPoliciesHeader, RecentPoliciesWrapper } from '../../components/RecentPolicies';
import { getRecentPoliciesRequest } from '../../components/RecentPolicies/Redux/actions';
import {
  getVisibleOmmTabs,
  buildOmmTabParams
} from '../../components/RecentPolicies/Components/RecentPoliciesWrapper'
import {
  buildSambaFilterParams,
  defaultSambaInputs
} from '../../components/RecentPolicies/Components/SambaPolicyFilters'
import { PARTNERS_WITH_RECENT_POLICIES, PARTNERS_GUID_ENUM } from '../../routes/PartnersEnum';
import { getPartnerGuid } from '../../lib/access.es6';
import PageNotFound from '../PageNotFound/index.es6';

class RecentPoliciesContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      size: 20,
    }
  }

  componentWillMount() {
    const partnerGuid = getPartnerGuid();

    // Check if the current partner has access to Recent Policies
    if (!PARTNERS_WITH_RECENT_POLICIES.includes(partnerGuid)) {
      return;
    }

    let payload = { page: 1, size: 20 };

    // OMM lands on the first New Business tab; the initial fetch must carry
    // the same status/date-range/date_discriminator params the wrapper sends
    // when that tab is (re)selected.
    if (partnerGuid === PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI) {
      const firstTab = getVisibleOmmTabs()[0];
      payload = {
        ...payload,
        ...(firstTab.needAction ? { fetchAll: true } : {}),
        ...buildOmmTabParams(firstTab)
      };
    }

    // Samba lands on the default filter view (start_date in the last 30
    // days) — the same params the filter panel is pre-filled with.
    if (partnerGuid === PARTNERS_GUID_ENUM.SAMBA) {
      payload = { ...payload, ...buildSambaFilterParams(defaultSambaInputs()) };
    }

    this.props.dispatch(getRecentPoliciesRequest(payload));
  }

  getPolicies = (payload = {}) => {
    const page = payload.page || 1;
    const size = payload.size || 20;
    const requestPayload = { ...payload, page, size };

    this.props.dispatch(getRecentPoliciesRequest(requestPayload));
  }

  render() {
    const partnerGuid = getPartnerGuid();

    // Check if the current partner has access to Recent Policies
    if (!PARTNERS_WITH_RECENT_POLICIES.includes(partnerGuid)) {
      return <PageNotFound />;
    }

    const isOmm = partnerGuid === PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI;
    const isSamba = partnerGuid === PARTNERS_GUID_ENUM.SAMBA;
    const { recentPoliciesData } = this.props;
    const { policies = [], loader = false, page = 1, size = 20, total = 0 } = recentPoliciesData || {};

    return (
      <>
        <RecentPoliciesHeader
          title={isOmm ? 'New Business' : 'Recent Policies'}
        />

        <RecentPoliciesWrapper
          getPolicies={this.getPolicies}
          policies={policies}
          loader={loader}
          page={page}
          size={size}
          total={total}
          isOmm={isOmm}
          isSamba={isSamba}
        />
      </>
    );
  }
}

export default connect((state) => ({
  recentPoliciesData: state.recentPoliciesData
}))(RecentPoliciesContainer);